export default __webpack_public_path__ + "static/media/compress.b2e48662.png";